module.exports = __webpack_public_path__ + "static/media/scene 2.8f786d48.jpg";